import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { TOrganisation } from './types';
import { ColoredIcon, FlexBox } from '../index';
import tokens from '@verifime/design-tokens';
import { alpha, useTheme } from '@mui/material/styles';

export default function OrganisationSelection({
  organisation,
  handleChange,
  modifiable = true,
  dataTestId,
}: {
  organisation: TOrganisation;
  handleChange?: () => void;
  modifiable?: boolean;
  dataTestId?: string;
}) {
  const theme = useTheme();

  return (
    <Stack
      borderRadius={tokens.borderRadiusSm}
      padding={`${tokens.spacingBase} ${tokens.spacingXs}`}
      gap={tokens.spacing2xs}
      bgcolor={alpha(theme.palette.action.selected, 0.4)}
      data-component="OrganisationSelection"
      data-testid={dataTestId}
    >
      <Stack
        spacing={tokens.spacing2xs}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Typography variant="h6">{organisation.subEntityName}</Typography>
        <Box>
          <ColoredIcon iconName="verifiedRounded" color="success" />
        </Box>
      </Stack>
      <Typography variant="subtitle1">{organisation.reportingEntityName}</Typography>
      {modifiable && (
        <Stack direction="row-reverse" justifyContent="flex-start" alignItems="flex-start">
          <Button
            variant="text"
            size="small"
            sx={{
              py: tokens.spacing2xs,
              px: tokens.spacingSm,
            }}
            onClick={handleChange}
            data-action="change-organisation"
          >
            Change
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
